import { DomainItem } from '@anm/api/modules/customDomains';
import { FC } from 'react';
import Listitem from '../ListItem';
import { ListWrapper, ListHead, LeftColumn, RightColumn } from './styles';

type DomainsListProps = {
  list: DomainItem[];
  selectDomain: (domain: string) => void;
  selectedDomain?: string;
};

const DomainsList: FC<DomainsListProps> = ({ list, selectedDomain, selectDomain }) => {
  const handleDomainSelect = (url: string) => {
    const newDomain = list.find(item => item.Host === url);

    newDomain && selectDomain(newDomain.Host);
  };

  return (
    <ListWrapper>
      <ListHead>
        <LeftColumn>Custom domain</LeftColumn>
        <RightColumn>Status</RightColumn>
      </ListHead>
      {list.map(item => (
        <Listitem key={item.Host} {...{ item, selectedDomain, handleDomainSelect }} />
      ))}
    </ListWrapper>
  );
};

export default DomainsList;
